import * as type from "../types";

export function setLoader(loaderNewValue) {
  return {
    type: type.SET_LOADER,
    payload: loaderNewValue,
  };
}
